<div class="selected">
  <img [src]="viewImage" alt="selected-image" />
</div>

<form name="gallery" class="gallery" *ngIf="creditType !== '1'">
  <ng-container *ngFor="let img of images; let i = index">
    <input id="image-{{ i }}" type="radio" name="gallery" />
    <label for="image-{{ i }}" (click)="clickViewImage(img.url)"
      ><img src="{{ img.url }}" alt="" width="100%" />
    </label>
  </ng-container>
</form>
